// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"21115f8d","77":"c57e5574","453":"eb649c84","757":"ff31598d","821":"88753b17","858":"2ed5584f","978":"9fdcab93"}[chunkId] + ".chunk.js";
};